module.exports = __webpack_public_path__ + "img/none.17634a46.png";